import { TranslationKeys } from './locales';

export const es: TranslationKeys = {
  common: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    search: 'Buscar',
    loading: 'Cargando',
    noData: 'No se encontraron datos',
    yes: 'Sí',
    no: 'No',
    all: 'Todo',
    yearUnit: '',
    register: 'Registrar',
    casesUnit: 'casos',
  },
  
  login: {
    title: 'Iniciar sesión',
    id: 'ID',
    password: 'Contraseña',
    loginButton: 'Iniciar sesión',
    findId: 'Buscar ID',
    findPassword: 'Buscar contraseña',
    idPlaceholder: 'Ingrese su ID',
    passwordPlaceholder: 'Ingrese su contraseña',
    keepLoggedIn: 'Mantener sesión iniciada',
    invalidCredentials: 'Las credenciales no son válidas. <br /> ¡Verifique su ID y contraseña!',
  },
  
  dashboard: {
    title: 'Panel de control',
    farmMachineryCount: 'Maquinaria agrícola en el mapa',
    totalMachinery: 'Total',
    unit: 'unidades',
    runningMachinery: 'En funcionamiento',
    stoppedMachinery: 'Detenido',
    map: 'Mapa',
    list: 'Lista',
  },
  
  control: {
    title: 'Control de accidentes agrícolas',
    farmMachineryOnMap: 'Maquinaria agrícola en el mapa',
    searchPlace: 'Ingrese lugar o dirección',
    placeAddress: 'Lugar/Dirección',
    normal: 'Normal',
    cadastral: 'Catastral',
    satellite: 'Satélite',
    eventDate: 'Fecha del evento',
    deviceName: 'Nombre del dispositivo',
    owner: 'Propietario',
    status: 'Estado',
    running: 'En funcionamiento',
    stopped: 'Detenido',
    noData: 'No se encontraron datos',
    realtimeDetectionHistory: 'Historial de detección en tiempo real',
    farmMachineryList: 'Lista de maquinaria agrícola',
    searchedFarmMachinery: 'Maquinaria agrícola encontrada',
    resultsPerPage: 'Resultados por página',
    realtimeOperationStatus: 'Estado de operación en tiempo real',
    danger: 'Peligro',
    caution: 'Precaución',
    operating: 'Operando',
    notOperating: 'No operando',
    rolloverAccident: 'Accidente de vuelco',
    searchDeviceOwner: 'Buscar por nombre de dispositivo o propietario',
    lastOperation: 'Última operación',
    dangerAccident: 'Peligro (accidente de vuelco)',
    deviceList: 'Lista de dispositivos',
    noDeviceFound: 'No se encontraron dispositivos',
    selectDetectionType: 'Seleccionar tipo de detección',
    selectDeviceType: 'Seleccionar tipo de dispositivo',
    totalFarmMachinery: 'Total de maquinaria agrícola',
    checkDate: 'Por favor verifique la fecha.',
    selectBothDates: 'Por favor seleccione tanto la fecha de inicio como la de fin.',
    group: 'Grupo',
    noRecord: 'Sin registro de conducción',
    operationRecord: 'Registro de operación',
    user: 'Usuario',
    unlockRolloverStatus: '¿Desbloquear el estado de vuelco del vehículo?',
    unlockRolloverContent: 'Si desbloquea, el estado de detección de accidentes se procesará normalmente.\nNo se puede cancelar después del procesamiento normal.',
    confirmUnlock: 'Sí, desbloquearé.',
    openContact: '¿Abrir contacto?',
    protectingPrivacy: 'Protegiendo la información personal del arrendatario.',
    openLesseeContact: '¿Abrir el contacto del arrendatario?',
    openContactButton: 'Abrir contacto',
    protectDevicePrivacy: (item: string) => `Para proteger la privacidad del dispositivo ${item}`,
    enterOfficerName: 'Por favor ingrese el nombre exacto del oficial que está viendo.',
    accidentDetected: (minutes: number, seconds: number) => `[ ${minutes} minutos ${seconds} segundos transcurridos después de la detección del accidente ]`,
    farmMachineryUsageReport: 'Reporte de uso de maquinaria agrícola',
    accidentDetectionRelease: 'Liberar detección de accidente',
    accidentDetectionReleaseReason: 'Por favor seleccione la razón para liberar la detección',
    accidentDetectionReleaseReasonDesc: 'Para entender la situación del accidente detectado,\npor favor seleccione la razón exacta de liberación.\nLa información de liberación se puede ver en [Historial de detección].',
    accidentDetectionReleaseReasonDesc2: 'Para entender la situación del accidente detectado,',
    accidentDetectionReleaseReasonDesc3: 'por favor seleccione la razón exacta de liberación.\nLa información de liberación se puede ver en [Historial de detección].',
    accidentDetectionReleaseButton: 'Liberar detección',
    accidentOccurred: 'Accidente ocurrido',
    dangerousDriving: 'Conducción peligrosa',
    areaExit: 'Salida del área',
    dangerousAreaEntry: 'Entrada a área peligrosa',
    batteryLow: 'Batería baja',
    engineAbandonment: 'Abandono del motor',
    rolloverAccidentDetected: 'Se ha detectado un accidente de vuelco.',
    checkUserSafetyImmediately: '¡Por favor verifique inmediatamente la seguridad del usuario!',
    // 농기계 사용 리포트 관련
    usageReportTitle: (name: string) => `Reporte de uso de maquinaria agrícola de ${name}`,
    closeReportConfirm: '¿Quieres cerrar el reporte?',
    deviceOperationStartDateMessage: 'Se ha recuperado la fecha de inicio de operación del dispositivo.',
    currentLocationError: 'No se puede recuperar la ubicación actual.',
    addressLookupError: 'Error de búsqueda de dirección:',
    ownedDeviceList: 'Lista de dispositivos propios',
    recentOperationHistory: 'Historial de operación reciente',
    operationEndLocation: 'Ubicación de fin de operación:',
    noRecentOperationHistory: 'No hay historial de operación reciente.',
    viewMap: 'Ver mapa',
    viewOperationHistory: 'Ver historial de operación',
    operationRunning: 'En operación',
    operationEnd: 'Fin de operación',
    // 소유자 정보 관련
    ownerInfo: 'Información del propietario',
    ownerLabel: 'Propietario',
    ownerContact: 'Contacto del propietario',
    currentLocation: 'Ubicación actual',
    contactViewConfirm: '¿Quieres ver el contacto?',
    contactViewContent: (item: string) => `Para la protección de la privacidad del dispositivo ${item},\npor favor ingresa el nombre exacto de la persona que toma acción.`,
    contactViewButton: 'Ver contacto',
    contactViewPlaceholder: 'Por favor ingresa el nombre de la persona que toma acción.',
    // 운행 관련
    lastOperationTime: 'Última operación',
    noOperationRecord: 'Sin registro de operación',
    // 차트 관련
    noDetectionInPeriod: 'No hay historial de detección en este período.',
    pleaseReselectDate: 'Por favor, vuelve a seleccionar la fecha.',
    // 기기 정보 모달 관련
    rentalPurpose: 'Propósito de alquiler',
    // 운행 기록 관련
    travelDistance: 'Distancia de viaje',
    farmMachineryVoltage: 'Voltaje de maquinaria agrícola',
    angle: 'Ángulo',
    addressUnavailable: 'No se puede verificar la dirección.',
    operationLabel: 'Operación',
    degreeUnit: '°',
    currentStatus: 'Estado actual',
    dailyInspectionRequiredMachineryList: 'Lista de maquinaria agrícola que requiere inspección diaria',
    // 상태 관련
    statusNormal: 'Normal',
    statusCaution: 'Precaución',
    statusDanger: 'Peligro',
    vehicleRollover: 'Volcado de vehículo',
    // 기기 정보 관련
    deviceType: 'Tipo de dispositivo',
    // 감지 종류 (필터용)
    all: 'Todos',
    vehicleRolloverEvent: 'Volcado de vehículo',
    dangerousDrivingEvent: 'Conducción peligrosa',
    engineAbandonmentEvent: 'Abandono del motor',
    areaExitEvent: 'Salida del área de uso',
    batteryLowEvent: 'Batería baja',
    theftDetection: 'Detección de robo',
    dangerousAreaEntryEvent: 'Entrada a zona peligrosa',
    // 기기 종류 (필터용)
    tractor: 'Tractor',
    speedSprayer: 'Pulverizador de velocidad',
    fourWheelMotorcycle: 'Motocicleta de cuatro ruedas',
    twoWheelMotorcycle: 'Motocicleta de dos ruedas',
    oneTonTruck: 'Camión de 1 tonelada',
    walkingManagement: 'Gestión a pie',
    ridingManagement: 'Gestión montada',
    agriculturalHighWorkVehicle: 'Vehículo de trabajo en altura agrícola',
    agriculturalTransportVehicle: 'Vehículo de transporte agrícola',
    agriculturalLoader: 'Cargador agrícola',
    ridingWeedCutter: 'Cortadora de malezas montada',
    ridingWeedRemover: 'Eliminadora de malezas montada',
    ridingTransplanter: 'Trasplantadora montada',
    fertilizerSpreader: 'Esparcidor de fertilizante',
    pesticideSpreader: 'Esparcidor de pesticidas',
    combine: 'Cosechadora',
    excavator: 'Excavadora',
    cultivator: 'Cultivador',
    branchCrusher: 'Trituradora de ramas',
    etc: 'Otros',
  },
  
  history: {
    title: 'Consulta de historial de detección',
    detectionTime: 'Hora de detección',
    eventType: 'Tipo de evento',
    deviceName: 'Nombre del dispositivo',
    owner: 'Propietario',
    dateRange: 'Rango de fechas',
    from: 'Desde',
    to: 'Hasta',
    searchedDetections: 'Detecciones encontradas',
    detectionNumber: 'Número de detección',
    deviceType: 'Tipo de dispositivo',
    deviceName2: 'Nombre del dispositivo',
    detectionDetails: 'Detalles de detección',
    detectedDateTime: 'Fecha y hora de detección',
    releasedDateTime: 'Fecha y hora de liberación',
    releaseReason: 'Razón de liberación',
    actionTakenBy: 'Acción tomada por',
    detectionDetailView: 'Vista detallada de detección',
    noDataAvailable: 'No se encontraron datos.',
    noLocationData: 'No se puede determinar la ubicación de estos datos.',
    downloadHistory: 'Descargar historial',
    selectDeviceType: 'Seleccionar tipo de dispositivo',
    selectDetectionType: 'Seleccionar tipo de detección',
    searchDeviceOwner: 'Buscar por nombre de dispositivo o propietario',
    casesUnit: 'casos',
    lastOperation: 'Última operación',
    distance: 'Distancia recorrida',
    machineryVoltage: 'Voltaje de maquinaria',
    currentStatus: 'Estado actual',
    normal: 'Normal',
    detectionDetails2: 'Detalles de detección',
    detectionDateTime: 'Fecha y hora de detección',
    detectionLocation: 'Ubicación de detección',
    releaseReason2: 'Razón de liberación',
    user2: 'Usuario',
    userContact: 'Contacto del usuario',
    guardian: 'Tutor',
    guardianContact: 'Contacto del tutor',
    guardianUserRelation: 'Relación entre tutor y usuario',
    operating: 'Operando',
    deviceTypeLabel: 'Tipo de dispositivo',
  },
  
  mobileList: {
    title: 'Lista de dispositivos móviles',
    searchDeviceOwner: 'Buscar por nombre de dispositivo o propietario',
    from: 'Desde',
    to: 'Hasta',
    selectDeviceType: 'Seleccionar tipo de dispositivo',
    selectDetectionType: 'Seleccionar tipo de detección',
    group: 'Grupo',
    registerDevice: 'Registrar dispositivo',
    searchedDevices: 'Dispositivos encontrados',
    unit: 'unidades',
    deviceName: 'Nombre del dispositivo',
    deviceType: 'Tipo de dispositivo',
    owner: 'Propietario',
    operationStatus: 'Estado de\noperación',
    lastOperationDate: 'Fecha de última\noperación',
    terminalSN: 'S/N del\nterminal',
    machineryBattery: 'Bat de\nmaquinaria',
    terminalBattery: 'Bat del\nterminal',
    testMode: 'Modo de\nprueba',
    deviceDetail: 'Detalles del dispositivo',
    viewOnMap: 'Ver en mapa',
    deviceDelete: 'Eliminar dispositivo',
    testModeActivate: '¿Cambiar el estado del modo?',
    testModeDeactivate: '¿Desactivar el modo de prueba?',
    testModeActivateContent: 'Si cambia al modo de prueba,\nno podrá recibir alertas de accidentes de este dispositivo,\ny podrá recibirlas nuevamente después de desactivar el modo de prueba.',
    testModeDeactivateContent: 'Si desactiva el modo de prueba,\npueden ocurrir alertas de accidentes de este dispositivo.',
    deleteDevice: '¿Eliminar este dispositivo?',
    deleteDeviceContent: 'Si elimina el dispositivo, no podrá ver la información de este dispositivo,\ny la información del dispositivo eliminado no se puede recuperar.',
    confirmDelete: 'Eliminar',
    exportInstallHistory: 'Exportar historial de instalación',
    exportCount: 'casos',
    noRecord: 'Sin registro de conducción',
    inspectionNeeded: 'Se requiere inspección del terminal.',
    clipboardCopied: 'Copiado al portapapeles.',
    noDownloadAvailable: 'No hay archivos disponibles para descargar.',
    downloadSuccess: 'Descarga de archivo exitosa',
  },
  
  deviceRegister: {
    title: 'Registro de dispositivo',
    deviceName: 'Nombre del dispositivo',
    deviceNamePlaceholder: 'Máximo 20 caracteres',
    owner: 'Propietario',
    ownerPlaceholder: 'Seleccione propietario',
    selectOwner: 'Propietario',
    deviceType: 'Tipo de dispositivo',
    terminalSerialNumber: 'Número de serie del terminal',
    terminalSerialPlaceholder: '8-16 caracteres básicos',
    terminalIMEI: 'IMEI del terminal',
    terminalIMEIPlaceholder: '15 dígitos numéricos',
    numbersOnly: 'Ingrese solo números.',
    confirmRegister: '¿Registrar maquinaria agrícola?',
    confirmRegisterContent: 'El contenido registrado se puede modificar posteriormente.',
    confirmRegisterButton: 'Registrar',
    cancelRegister: '¿Cancelar registro de dispositivo?',
    cancelRegisterContent: 'Si presiona confirmar, el contenido ingresado se restablecerá.',
    checkInput: 'Por favor verifique la entrada una vez más.',
    registerCancel: 'Cancelar',
    registerButton: 'Registrar',
    registerLoading: 'Registrar',
    noRegisterButton: 'Registrar',
    ownerRequired: 'Por favor seleccione un propietario.',
    ownerError: 'Este dato no se puede seleccionar.',
    imageUploadSuccess: 'Imagen de usuario registrada exitosamente',
    imageUploadError: 'Ocurrió un error al registrar la imagen.',
    bulkUploadTitle: 'Por favor cargue el archivo Excel con información del dispositivo.',
    bulkUploadContent: 'Por favor cargue el archivo Excel con información de registro del dispositivo.\nPara un registro preciso del dispositivo, use solo archivos escritos según el formato.',
  },
  
  deviceDetail: {
    title: 'Detalles del dispositivo',
    titleEdit: 'Editar dispositivo',
    deviceName: 'Nombre del dispositivo',
    owner: 'Propietario',
    ownerPlaceholder: 'Seleccione propietario',
    ownerSelect: 'Propietario',
    registrationDate: 'Fecha de registro del dispositivo',
    deviceType: 'Tipo de dispositivo',
    terminalSerialNumber: 'Número de serie del terminal',
    terminalIMEI: 'IMEI del terminal',
    modifyDevice: 'Modificar',
    modifyComplete: 'Completar',
    cancelModify: '¿Cancelar modificación de información del dispositivo?',
    cancelModifyContent: 'Si presiona confirmar, el contenido modificado se restablecerá.',
    ownerRequired: 'Por favor seleccione un propietario.',
    ownerError: 'Este dato no se puede seleccionar.',
    numbersOnly: 'Ingrese solo números.',
    save: 'Guardar',
    reset: 'Cancelar',
    installPhotos: 'Fotos de instalación',
    overallView: 'Vista completa de maquinaria',
    terminalInstallation: 'Vista de instalación del terminal',
    terminalSerialSticker: 'Pegatina de número de serie del terminal',
    powerWiringStatus: 'Estado del cableado de alimentación',
    machineryTypePlate: 'Placa de tipo de maquinaria',
    userPhoto: 'Foto del usuario',
    noImage: 'Sin imagen',
  },
  
  notice: {
    title: 'Avisos',
    goBack: 'Volver a la lista',
    confirm: 'Confirmar',
    edit: 'Editar',
    editContent: 'Editar contenido',
    delete: 'Eliminar',
    deleteTitle: '¿Eliminar aviso?',
    deleteContent: 'El aviso eliminado no se mostrará al propietario\ny no se puede recuperar.',
    register: 'Registrar aviso',
    noNotice: 'No hay avisos registrados.',
    previousNotice: 'Aviso anterior',
    nextNotice: 'Siguiente aviso',
    new: 'Nuevo',
    web: 'WEB',
    app: 'APP',
    write: 'Escribir aviso',
    editTitle: 'Editar aviso',
    category: 'Categoría de aviso',
    noticeTitle: 'Título del aviso',
    titlePlaceholder: 'Ingrese el título (máximo 100 caracteres)',
    cancel: 'Cancelar',
    complete: 'Completar',
    registerConfirm: '¿Registrar aviso?',
    registerContent: 'El contenido del aviso se puede modificar o eliminar,\ny los avisos escritos pueden ser verificados por los propietarios.',
    cancelConfirm: '¿Volver a la lista?',
    cancelContent: 'Si presiona el botón de confirmar,\nel contenido escrito hasta ahora no se guardará.',
    editBreadcrumb: 'Editar aviso',
    detailBreadcrumb: 'Detalles del aviso',
    contentPlaceholder: 'Ingrese el contenido del texto (máximo 2000 caracteres)',
    imageFormatInfo: '* Los formatos de archivo de imagen adjuntos permitidos son png, jpg, jpeg.',
    imageSizeInfo: '* El límite de tamaño de un archivo de imagen es de 5MB y se pueden adjuntar hasta 5 archivos.',
    maxLengthExceeded: 'Se excedieron los 2000 caracteres.',
    invalidFileFormat: 'Por favor verifique el formato del archivo.\nLos formatos de archivo que se pueden cargar son png, jpg, jpeg.',
    maxImagesExceeded: 'Se pueden adjuntar máximo 5 imágenes.',
    maxSizeExceeded: 'Se pueden adjuntar imágenes de máximo 5MB.',
    confirmTitle: 'Por favor verifique el contenido.',
  },
  
  statistics: {
    title: 'Estadísticas de detección',
    search: 'Consultar',
    download: 'Descargar',
    invalidPeriod: 'Por favor seleccione nuevamente la fecha\ncon un período de 7 días o más.',
    noData: 'No hay historial en el período correspondiente.\nPor favor seleccione nuevamente la fecha.',
    monthView: 'Ver por mes',
    operatedMachinery: 'Maquinaria agrícola operada',
    totalMachinery: 'Total de maquinaria agrícola',
    dailyDetections: 'Historial de detección diaria (casos)',
    periodDetections: 'Historial de detección del período (%)',
    hourlyDetections: 'Historial de detección por hora (casos)',
    detectByType: 'Historial de detección por tipo',
    detectList: 'Lista de historial de detección encontrado',
    totalDetections: 'Total de historial de detección',
    rolloverDetections: 'Historial de detección de accidente de vuelco',
    dangerousDrivingDetections: 'Historial de detección de conducción peligrosa',
    outOfAreaDetections: 'Historial de detección de salida del área de uso',
    batteryAnomalyDetections: 'Historial de detección de anomalía de batería',
    ignitionNeglectDetections: 'Historial de detección de descuido de encendido',
    cases: 'casos',
    units: 'unidades',
    selectPeriod: 'Seleccionar período',
    selectPeriodPlaceholder: '-- Seleccionar período --',
    oneMonth: '1 mes',
    threeMonths: '3 meses',
    sixMonths: '6 meses',
    oneYear: '1 año',
    timeUnit: '(unidad: hora)',
    monthlyDetections: 'Historial de detección mensual (casos)',
    dailyView: 'Ver por día',
    detectionHistory: 'Historial de detección',
    dayOfWeek: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dangerousAreaEntryDetections: 'Detecciones de entrada a zona peligrosa',
    user: 'Usuario',
    lastOperation: 'Última operación',
    noDrivingRecord: 'Sin registro de conducción',
  },
  
  manageUser: {
    title: 'Gestión de usuarios',
    userList: 'Lista de usuarios',
    addUser: 'Agregar usuario',
    editUser: 'Editar usuario',
    deleteUser: 'Eliminar usuario',
    register: 'Registro de cuenta',
    permissionManagement: 'Gestión de permisos de cuenta',
    cancelRegisterTitle: '¿Cancelar registro de usuario?',
    cancelRegisterContent: 'Si presiona confirmar, el contenido ingresado se restablecerá.',
    userName: 'Nombre de usuario',
    phone: 'Número de teléfono',
    email: 'Correo electrónico',
    area: 'Grupo',
    grade: 'Grado',
    status: 'Estado',
    searchUser: 'Buscar por ID de usuario o nombre de usuario',
    userAccountInfo: 'Información de cuenta de usuario',
    myAccountInfo: 'Información de mi cuenta',
    confirmDelete: '¿Eliminar esta cuenta?',
    deleteWarning: 'El usuario ya no podrá usar esta cuenta,\ny la información de la cuenta eliminada no se puede recuperar.',
    accountName: 'Nombre de cuenta',
    userId: 'ID',
    contact: 'Contacto',
    address: 'Dirección',
    detailAddress: 'Dirección detallada',
    accountCreationDate: 'Fecha de creación de cuenta',
    viewDetails: 'Ver detalles',
    viewContactRecord: 'Ver registro de contacto',
    recordsFound: 'Registros encontrados',
    category: 'Categoría',
    contactViewTime: 'Tiempo de visualización de contacto',
    reader: 'Lector',
    deleteAccount: 'Eliminar cuenta',
    resetPassword: 'Restablecer contraseña',
    noDataFound: 'No se encontraron datos.',
    deleteMessage: '¿Realmente desea eliminar?',
    searchPlaceholder: 'Buscar',
    peopleUnit: 'personas',
    passwordConfirm: 'Confirmar contraseña',
    maxCharacters: 'Máximo 20 caracteres',
    passwordRequirements: 'Incluir caracteres especiales, mínimo 8 caracteres',
    emailExample: 'Ejemplo: test123@nongcall.com',
    phoneExample: 'Ejemplo: 010-1234-1234 / 031-123-1234',
    postcodeSearch: 'Buscar código postal',
    clear: 'Limpiar',
    accountNamePlaceholder: 'Ingrese el nombre de la institución responsable que usa el sistema de control (máximo 20 caracteres)',
    addressPlaceholder: 'Ingrese la dirección de la institución responsable que usa el sistema de control',
    userImageAlt: 'Imagen de usuario',
    emailMaxCharacters: 'Máximo 50 caracteres',
    phoneIncludeDash: 'Incluir guiones al ingresar',
    detailAddressMaxCharacters: 'Máximo 100 caracteres',
    detectionNotification: 'Notificación de situación de detección',
    functionManagement: 'Gestión de funciones',
    dangerAccident: 'Peligro (accidente)',
    warningDangerousArea: 'Precaución (entrada a área peligrosa)',
    batteryAbnormal: 'Anomalía de batería',
    areaExit: 'Salida del área de uso',
    detectionRelease: 'Procesamiento de liberación de detección',
    deviceInfoModify: 'Modificar información del dispositivo',
    resetPasswordTitle: '¿Restablecer contraseña?',
    resetPasswordContent: 'La contraseña se restablecerá cuando presione confirmar.',
    // Modal de ver contacto
    openContact: '¿Deseas ver el contacto?',
    protectingPrivacy: 'Para proteger la información personal del usuario,\npor favor ingresa el nombre exacto del responsable que visualiza.',
    openContactButton: 'Ver contacto',
    enterOfficerName: 'Por favor ingresa el nombre del responsable.',
    // Mostrar contacto
    noContact: 'Sin contacto',
    viewContact: 'Ver contacto',
    // Modal de mi página
    viewAccountInfo: '¿Deseas ver la información de la cuenta?',
    enterPasswordForPrivacy: 'Para proteger la información personal,\npor favor ingresa la contraseña de la cuenta.',
    enterPasswordPlaceholder: 'Por favor ingresa la contraseña.',
    confirming: 'Confirmando...',
  },
  
  manageNok: {
    title: 'Gestión de destinatarios adicionales',
    nokList: 'Lista de destinatarios adicionales',
    addNok: 'Agregar destinatario adicional',
    editNok: 'Editar destinatario adicional',
    deleteNok: 'Eliminar destinatario adicional',
    nokName: 'Nombre',
    relationship: 'Relación',
    phone: 'Teléfono',
    priority: 'Prioridad',
    recipientInfo: 'Información del destinatario de notificación adicional',
    recipientContact: 'Contacto del\ndestinatario adicional',
    ownerName: 'Nombre del propietario',
    ownerContact: 'Contacto del\npropietario',
    accountCreationTime: 'Tiempo de creación de cuenta',
    viewDetailInfo: 'Ver detalles',
    deleteAccount: 'Eliminar cuenta',
    searchPlaceholder: 'Buscar por ID o nombre del destinatario',
    registerRecipient: 'Registrar destinatario adicional',
    sortByName: 'Ordenar por nombre',
    sortByContact: 'Ordenar por contacto del destinatario',
    sortByOwnerName: 'Ordenar por nombre del propietario',
    sortByOwnerContact: 'Ordenar por contacto del propietario',
    sortByRelationship: 'Ordenar por relación',
    sortByCreationTime: 'Ordenar por tiempo de creación',
    defaultSort: 'Orden predeterminado',
    deleteConfirmTitle: '¿Eliminar esta cuenta?',
    deleteConfirmContent: 'Esta información del destinatario ya no estará disponible,\ny la información eliminada no se puede recuperar.',
    noDataFound: 'No se encontraron datos.',
    registerRecipientTitle: 'Registrar destinatario adicional',
    registerRecipientSubtitle: 'Seleccionar propietario',
    editRecipientTitle: 'Editar destinatario adicional',
    editRecipientSubtitle: 'Seleccionar propietario',
    cancelRegisterTitle: '¿Cancelar registro?',
    cancelRegisterContent: 'Toda la información ingresada será eliminada.',
    selectOwner: 'Seleccionar propietario',
    nameLabel: 'Nombre',
    contactLabel: 'Contacto',
    ownerLabel: 'Propietario',
    relationshipLabel: 'Relación',
    namePlaceholder: 'Nombre del destinatario',
    contactPlaceholder: 'Solo números (mínimo 10 dígitos)',
    relationshipPlaceholder: 'Ingrese la relación',
    contactMinLength: 'El contacto debe tener al menos 10 dígitos.',
    contactOnlyNumbers: 'El contacto solo debe contener números.',
    registerSuccess: 'Destinatario registrado exitosamente',
    peopleUnit: 'personas',
    detailInfoTitle: 'Detalles del destinatario',
    editInfoTitle: 'Editar detalles del destinatario',
    editSuccess: 'Destinatario editado exitosamente',
    cancelEditTitle: '¿Cancelar edición del destinatario?',
    cancelEditContent: 'Toda la información ingresada será eliminada.',
    editComplete: 'Edición completada',
    maxCharacters: 'Máximo 20 caracteres',
    includeDash: 'Incluir guiones al ingresar.',
  },
  
  manageCustomer: {
    title: 'Gestión de propietarios',
    customerList: 'Lista de propietarios',
    addCustomer: 'Agregar propietario',
    editCustomer: 'Editar propietario',
    deleteCustomer: 'Eliminar propietario',
    customerName: 'Nombre del propietario',
    phone: 'Teléfono',
    memo: 'Nota',
    ownerInfo: 'Información del propietario',
    ownerNumber: 'Número del\npropietario',
    contact: 'Contacto',
    name: 'Nombre',
    address: 'Dirección',
    detailAddress: 'Dirección detallada',
    group: 'Grupo',
    viewDetailInfo: 'Ver detalles',
    deleteAccount: 'Eliminar cuenta',
    searchPlaceholder: 'Buscar por ID o nombre del propietario',
    registerOwner: 'Registrar propietario',
    sortByNumber: 'Ordenar por número',
    sortByContact: 'Ordenar por contacto',
    sortByName: 'Ordenar por nombre',
    sortByAddress: 'Ordenar por dirección',
    sortByDetailAddress: 'Ordenar por dirección detallada',
    sortByGroup: 'Ordenar por grupo',
    defaultSort: 'Orden predeterminado',
    deleteConfirmTitle: '¿Eliminar esta cuenta?',
    deleteConfirmContent: 'El propietario no podrá usar esta cuenta,\ny la información de la cuenta eliminada no se puede recuperar.',
    noDataFound: 'No se encontraron datos.',
    peopleUnit: 'personas',
    casesUnit: 'casos',
    noAddress: 'Sin dirección',
    noGroup: 'Sin grupo',
    noDetailAddress: 'Sin dirección detallada',
    detailAddressLabel: 'Dirección detallada',
    detailInfoTitle: 'Detalles del propietario',
    editInfoTitle: 'Editar propietario',
    ownerName: 'Nombre del propietario',
    ownerContact: 'Contacto del propietario (ID)',
    password: 'Contraseña',
    joinDate: 'Fecha de registro',
    other: 'Otro',
    groupLabel: 'Grupo',
    modifyInfoTitle: 'Editar detalles del propietario',
    modifyComplete: 'Edición completada',
    cancelModifyTitle: '¿Cancelar edición del propietario?',
    cancelModifyContent: 'La información ingresada se restablecerá cuando presione confirmar.',
    invalidPassword: 'Contraseña no válida.',
    passwordSpaceError: 'La contraseña no puede contener espacios.',
    passwordRequirements: 'Debe incluir al menos una letra, número y carácter especial,\ny tener al menos 8 caracteres.',
    maxCharacters20: 'Máximo 20 caracteres',
    maxCharacters100: 'Máximo 100 caracteres',
    includeDash: 'Incluir guiones al ingresar.',
    addressPlaceholder: 'Dirección',
    passwordPlaceholder: 'Letras, números, caracteres especiales, 8+ caracteres',
    groupSrLabel: 'Organización',
    // 연락처 관련
    noContact: 'Sin contacto',
    viewContact: 'Ver contacto',
    registerInfoTitle: 'Registrar propietario',
    registerComplete: 'Registrar',
    cancelRegisterTitle: '¿Cancelar registro del propietario?',
    cancelRegisterContent: 'La información ingresada se restablecerá cuando presione confirmar.',
    registerSuccess: 'Propietario registrado exitosamente',
    numbersOnly: 'Ingrese solo números.',
    otherPlaceholder: 'Otro ingreso',
    noDashNumbers: 'Solo números sin guiones',
  },
  
  manageMobility: {
    title: 'Gestión de maquinaria agrícola',
    mobilityList: 'Lista de maquinaria agrícola',
    addMobility: 'Agregar maquinaria agrícola',
    mobilityName: 'Nombre de maquinaria',
    mobilityType: 'Tipo de maquinaria',
    owner: 'Propietario',
    status: 'Estado',
  },
  
  eventTypes: {
    accident: 'Vuelco de vehículo',
    battery: 'Batería baja',
    dangerous: 'Entrada a área peligrosa',
    userArea: 'Salida del área de uso',
    emergency: 'Llamada de emergencia',
    keyOn: 'Descuido de encendido',
  },
  
  status: {
    normal: 'Normal',
    warning: 'Advertencia',
    error: 'Error',
    running: 'En funcionamiento',
    stopped: 'Detenido',
    idle: 'En espera',
  },
  
  navigation: {
    home: 'Inicio',
    accidentControl: 'Control de accidentes',
    detectionHistory: 'Consulta de historial de detección',
    statistics: 'Estadísticas',
    notice: 'Avisos',
    management: 'Gestión',
    farmMachineryManagement: 'Gestión de maquinaria agrícola',
    userAccountManagement: 'Gestión de cuentas de usuario',
    ownerManagement: 'Gestión de propietarios',
    additionalRecipientManagement: 'Gestión de destinatarios adicionales',
    sitemap: 'Mapa del sitio',
    shopZone: 'Zonas seguras de oficinas',
    shopZoneMap: 'Mapa de zonas seguras',
    shopZoneAlarms: 'Alarmas suprimidas',
    bigdata: 'Análisis de big data',
    logout: 'Cerrar sesión',
    honorific: '',
  },
};